import { getUserPermissions } from '@/api/permission'

// 权限检查工具类
class PermissionChecker {
  constructor() {
    this.permissions = []
    this.loaded = false
  }

  // 初始化权限
  async init() {
    try {
      const response = await getUserPermissions()
      this.permissions = response.data || []
      this.loaded = true
      return this.permissions
    } catch (error) {
      console.error('获取用户权限失败:', error)
      this.permissions = []
      this.loaded = true
      return []
    }
  }

  // 检查是否有指定权限
  hasPermission(permission) {
    if (!this.loaded) {
      console.warn('权限尚未初始化，请先调用 init() 方法')
      return false
    }
    
    // 超级管理员拥有所有权限
    if (this.isSuperAdmin()) {
      return true
    }
    
    return this.permissions.includes(permission)
  }

  // 检查是否有任意一个权限
  hasAnyPermission(permissions) {
    if (!this.loaded) {
      console.warn('权限尚未初始化，请先调用 init() 方法')
      return false
    }
    
    // 超级管理员拥有所有权限
    if (this.isSuperAdmin()) {
      return true
    }
    
    return permissions.some(permission => this.permissions.includes(permission))
  }

  // 检查是否有所有权限
  hasAllPermissions(permissions) {
    if (!this.loaded) {
      console.warn('权限尚未初始化，请先调用 init() 方法')
      return false
    }
    
    // 超级管理员拥有所有权限
    if (this.isSuperAdmin()) {
      return true
    }
    
    return permissions.every(permission => this.permissions.includes(permission))
  }

  // 获取用户权限列表
  getPermissions() {
    return this.permissions
  }

  // 检查是否为超级管理员
  isSuperAdmin() {
    const userInfo = localStorage.getItem('admin_user_info')
    if (userInfo) {
      try {
        const user = JSON.parse(userInfo)
        return user.role_code === 'admin'
      } catch (e) {
        console.error('解析用户信息失败:', e)
      }
    }
    return false
  }

  // 重置权限
  reset() {
    this.permissions = []
    this.loaded = false
  }
}

// 创建单例实例
const permissionChecker = new PermissionChecker()

export default permissionChecker